import styled from 'styled-components';
import { Link, LinkProps, P, T3, T4, T4Props } from 'ia-react-core';
import { FC } from 'react';

export const StyledSection = styled.section`
  border-bottom: 1px solid ${({ theme }) => theme.colors.gray3};
  margin-bottom: 36px;
  :last-child {
      margin-bottom: 0;
  }
  padding-left: 2px;
  padding-right: 2px;
`;

export const StyledContainer = styled.section`
  padding-right: 30px;
`;

export const StyledT = styled(T3)`
  margin-bottom: 25px;
`;

/// Shared Styles ///

export const StyledLink = styled<FC<LinkProps>>(Link) <{ unread: boolean }>`
  position: relative;
  padding: 17px 16px;
  border-top: 1px solid ${({ theme }) => theme.colors.gray3};
  cursor: pointer;
  width: 100%;
  text-align: inherit;
  background-color: inherit;
  outline: none;
  white-space: normal;

  &:focus {
    background-color: ${({ theme }) => theme.colors.blue14};
  }

  ${({ unread, theme }) => unread && `
    background-color: ${theme.colors.blue12};
    `}

  &:hover {
    text-decoration : none;
    background-color: ${({ theme }) => theme.colors.blue12};
    ${({ unread, theme }) => unread && `
      background-color: ${theme.colors.blue14};
    `}
  }

  &:active {
    background-color:  ${({ theme }) => theme.colors.blue14};
    ${({ unread, theme }) => unread && `
      background-color: ${theme.colors.blue15};
    `}
  }
`;

export const StyledT4 = styled<FC<T4Props & { isRead: boolean }>>(T4)`
  color: ${({ theme }) => theme.colors.blue5};
  font-size: 14px;
  margin-bottom: 6px;
  font-weight: ${({ isRead }) => isRead ? '600' : '700'};
`;

export const StyledDiv = styled.div`
  margin-right: 30px;
`;

export const StyledP = styled(P)`
  font-family: 'Open Sans', sans-serif;
  font-weight: 400;
  line-height: 1.29;
  margin-bottom: 0;
`;
